export default __webpack_public_path__ + "static/media/ic_postal_service.565824d1.svg";